<div class="required-reading-container">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="widget-header h4" i18n="my req reading header@@my-req-reading-header">Your required reading</h2>
            <h3 class="h6">
                <span class="text-muted" i18n="my req reading sub header@@my-req-reading-sub-header">
                    In the list below you'll find content that you are required to read by your organisation. After reading, you can confirm by hovering over the title of the content item and clicking the check mark.
                </span>
                <span class="text-muted" i18n="my req reading sub header@@my-req-reading-sub-header-2">
                    When you click on an item it will open in a new tab. You can navigate back here at any time by closing or switching the tab.
                </span>
            </h3>
        </div>
        <div>
            <mat-slide-toggle [checked]="showHasRead" (change)="handleShowHasRead($event)" (keyup.arrowright)="handleShowHasRead($event)" (keyup.arrowleft)="handleShowHasRead($event)" aria-label="Show read" title="Show read" i18n-title="@@my-req-reading-show-read" i18n="my req reading show read@@my-req-reading-show-read">Show read</mat-slide-toggle>
        </div>
    </div>
    <div *ngIf="readingItems$ | async as readingItems" class="row mt-4">
        <div *ngFor="let item of readingItems" class="col-6 col-sm-4 col-md-3 mb-2 reading-item d-flex">
            <div class="text-truncate">
                <i class="ms-Icon ms-Icon--RedEye accent-2-color h5 m-0 mr-2 align-middle" aria-hidden="true"></i>
                <a href="{{item.ItemToRead.Url}}" [ngClass]="item.HasRead ? 'has-read' : ''" class="link-text-color required-reading-clickable-link">{{item.ItemToRead.Title}}</a>
            </div>
            <div *ngIf="allowMarkAsReadFromReqReadList && !item.HasRead" class="ml-2">
                <button mat-icon-button
                        class="mark-as-read-btn"
                        (click)="markAsRead(item)"
                        aria-label="Click to mark this item as read"
                        i18n-aria-label="@@confirm-read-btn-title"
                        i18n-title="@@confirm-read-btn-title"
                        title="Click to mark this item as read">
                    <i class="ms-Icon ms-Icon--ReceiptCheck" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="loading" class="d-flex justify-content-center mt-4 mb-4">
      <mat-spinner [diameter]="50">
      </mat-spinner>
    </div>
</div>
